document.addEventListener('DOMContentLoaded', function () {
  const trigerLinks = document.querySelectorAll('[data-block-trigger-handle]');
  trigerLinks.forEach(trigerLink => {
    trigerLink.addEventListener('click', (e) => {
      const target = e.currentTarget;
      const wrapper = target.closest('.section-wrapper');
      const links = wrapper.querySelectorAll('[data-block-trigger-handle]');
      const blocks = wrapper.querySelectorAll('[data-property]');
      const handle = target.dataset.blockTriggerHandle;
      links.forEach(link => {
        link.classList.toggle('active', link.dataset.blockTriggerHandle == handle);
      });
      blocks.forEach(block => {
        block.classList.toggle('hidden', block.dataset.property != handle);
      });
    })
  })
});